import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { DangerousAPI } from "../../../axios/api";
import { useAbortedEffect, useHookForm } from "../../../components/hooks";

import {
  FormCheckbox,
  FormInputtext,
} from "../../../components/formElement/index";
import { formatResData, checkFormUpdate } from "../../../service/common";
import {
  option_dangerous_eat_type,
  option_dangerous,
} from "../../../service/option";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function BackMemberSettingDangerous() {
  const route_params = useParams();
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const [reload, setReload] = useState({
    list: true,
  });
  const disabled = false;
  // 明細資料
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    r1: false,
    r2: false,
    r3: false,
    r4: false,
    r5: false,
    r6: false,
    r7: false,
    r8: false,
    r8_1: false,
    r8_2: false,
    r8_3: false,
    r8_4: false,
    r9: false,
    r10: false,
    r11: false,
    r12: false,
    r12_other: "",
  };
  const {
    handleSubmit,
    getValues,
    setValue,
    reset,
    trigger,
    watch,
    yup,
    setSchema,
    errors,
    setting,
  } = useHookForm({
    defaultValues,
  });
  // 監聽欄位
  const watchColumn = {
    data: watch("r8"),
    r12: watch("r12"),
  };

  useEffect(() => {
    setSchema(yup.object({}).required());
  }, []);

  // 動態判斷欄位
  useEffect(() => {
    let submitData = getValues();

    if (!submitData.r8) {
      setValue("r8_1", false);
      setValue("r8_2", false);
      setValue("r8_3", false);
      setValue("r8_4", false);
      trigger(["r8_1", "r8_2", "r8_3", "r8_4"]);
    }
  }, [watchColumn.data]);
  useEffect(() => {
    let submitData = getValues();

    if (!submitData.r12) {
      setValue("r12_other", "");
      trigger(["r12_other"]);
    }
  }, [watchColumn.r12]);

  useAbortedEffect(
    (signal) => {
      if (!reload.list || route_params.detailid === "add") {
        return;
      }

      dispatch(setProgress(true));

      let params = { memberid: route_params.detailid };

      DangerousAPI.getRisk_factorsByMemberid({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          if (!data) data = {};

          [...option_dangerous, ...option_dangerous_eat_type].forEach(
            (item) => {
              data[item.key] = data[item.key] === 1;
            }
          );

          let temp = formatResData(defaultValues, data);
          setApiData(data);
          reset(temp);
          setReload((state) => ({ ...state, list: false }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let jsonData = {
      ...submitData,
      memberid: Number(route_params.detailid),
      r1: 0,
    };
    [...option_dangerous, ...option_dangerous_eat_type].forEach(
      (item) => (jsonData[item.key] = jsonData[item.key] ? 1 : 0)
    );

    if (!checkFormUpdate(jsonData, apiData)) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      route_navigate("/back/member");
      return;
    }

    let promise,
      toast = "";
    if (!apiData.id) {
      // 新增
      promise = DangerousAPI.setRisk_factors({
        data: jsonData,
      });
      toast = "新增";
    } else {
      // 修改
      jsonData.id = apiData.id;
      promise = DangerousAPI.updateRisk_factors({
        data: jsonData,
      });
      toast = "編輯";
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `${toast}成功`,
            detail: "",
          })
        );
        route_navigate("/back/member");
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `${toast}失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <div className="border-round-lg bg-white mt-3 p-3">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="username"
              className={classNames(
                { "p-error": errors.username },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              危險因素
            </label>
            <div className="flex flex-column col-12 sm:col-10">
              {option_dangerous.map((dangerous, dIdx) => (
                <div
                  key={`dangerous_${dangerous.value}`}
                  className={classNames({
                    "mt-3": dIdx !== 0,
                  })}
                >
                  <div className="flex flex-column md:flex-row">
                    <FormCheckbox
                      className="flex justify-content-start m-0"
                      setting={setting}
                      data={{
                        name: dangerous.key,
                        label: dangerous.label,
                        value: true,
                        type: "checked",
                      }}
                    />

                    {dangerous.key === "r8" && (
                      <div className="flex flex-wrap align-items-center mt-3 ml-4 md:mt-0 md:ml-0">
                        <span className="mr-2">{`(`}</span>
                        {option_dangerous_eat_type.map((eat) => (
                          <FormCheckbox
                            className="flex justify-content-start m-0 mr-2 my-1 md:my-0"
                            setting={setting}
                            data={{
                              name: eat.key,
                              label: eat.label,
                              value: true,
                              type: "checked",
                              disabled: !getValues("r8"),
                            }}
                          />
                        ))}
                        {`)`}
                      </div>
                    )}

                    {dangerous.key === "r12" && getValues("r12") && (
                      <FormInputtext
                        className="md:ml-2 mt-2 md:mt-0"
                        setting={setting}
                        data={{
                          name: "r12_other",
                          placeholder: "其他危險因素",
                          disabled: !getValues("r12"),
                        }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="field col-12 text-right">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => route_navigate("/back/member")}
            />
            {!disabled && (
              <Button type="submit" label="儲存" className="ml-2 px-3" />
            )}
          </div>
        </form>
      </div>
    </>
  );
}
